// extracted by mini-css-extract-plugin
module.exports = {"button":"supplier-list-filters-btn_button__3v_m4","filtersCounter":"supplier-list-filters-btn_filtersCounter__peO9i"};